<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Payroll Location Group Access</h1>
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn to="/payloc-group-access/create" icon v-on="on">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New</span>
      </v-tooltip>
      <pagination :show-dense="false" :show-title="false" :headers="headers">
        <template slot="actions" slot-scope="{ item }">
          <v-btn
            @click.stop="edit(item)"
            text
            color="primary"
            icon
            v-if="userAccess.edit >= 1"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template slot="payLoc" slot-scope="{ item }">
          <v-btn @click.stop="viewPayLoc(item)" text color="info">View</v-btn>
        </template>
      </pagination>
    </v-container>
    <!-- Dialog -->
    <v-dialog v-model="payLocDialog" width="500" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Payroll Locations</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense fixed-header>
            <tbody>
              <tr v-for="item in payLocations" :key="item.locId">
                <td>{{ item.locName }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="payLocDialog = false" color="error">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/userAccess";
export default {
  metaInfo: {
    title: "Payroll Location Group Access",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    Pagination
  },
  data: () => ({
    headers: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: "action"
      },
      {
        text: "Employee Code",
        align: "left",
        //sortable: false,
        value: "empCode"
      },
      {
        text: "Name",
        align: "left",
        //sortable: false,
        value: "fullName"
      },
      {
        text: "Payroll Location",
        align: "left",
        sortable: false,
        value: "payLoc"
      }
    ],
    payLocDialog: false,
    payLocations: []
  }),
  methods: {
    viewPayLoc(item) {
      this.payLocDialog = true;
      this.$axios
        .get(`${API_ENDPOINT}/payloc/${item.empCode}`)
        .then(({ data }) => {
          this.payLocations = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    edit(item) {
      this.$router.push(`/payloc-group-access/edit/${item.empCode}`);
    }
  },
  created() {
    this.getUserAccessRights("AddUsrGrp");
  }
};
</script>